import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrenciesService } from 'src/app/api/currencies.service';
import { Currency } from 'src/app/models/currency';
import { DeviceService } from 'src/app/services/device.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
  styleUrls: ['./broker.component.scss'],
  providers: [DeviceService]
})
export class BrokerComponent implements OnInit, AfterViewInit {
  @ViewChild('videoDesktop') videoDesktop: ElementRef<HTMLVideoElement>;
  @ViewChild('videoMobile') videoMobile: ElementRef<HTMLVideoElement>;

  isOS = true;
  lang: string;

  constructor(
    private localeService: LocaleService,
    private deviceService: DeviceService,
    private currenciesService: CurrenciesService,
  ) {}

  ngOnInit() {
    this.isOS = this.deviceService.isOS();
    this.lang = this.localeService.currentLocale;
  }

  ngAfterViewInit() {
    this.playVideo(this.videoDesktop?.nativeElement);
    this.playVideo(this.videoMobile?.nativeElement);
  }

  playVideo(video: HTMLVideoElement) {
    if (video) {
      video.muted = true;
      video.play();
      video.oncanplaythrough = function() {
        video.muted = true;
        video.play();
      };
    }
  }

  public currencies$: Observable<Currency[]> =
      this.currenciesService.getCrypto();
}
